import { render, staticRenderFns } from "./TwoFactorAuth.vue?vue&type=template&id=067d3360&scoped=true&"
import script from "./TwoFactorAuth.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuth.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorAuth.vue?vue&type=style&index=0&id=067d3360&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067d3360",
  null
  
)

export default component.exports